import { instance } from "../api";

const getAreas = () => {
  return instance
    .get<{ termin: string }[]>("/reclamation/area")
    .then((res) => res.data);
};

const getStreets = ({ area }: { area: string }) => {
  return instance
    .get<{ termin: string }[]>("/reclamation/dates", {
      params: {
        area,
      },
    })
    .then((res) => res.data);
};
const getDates = ({
  street,
  homeNumber,
  place,
  reclamationReason,
  type,
}: {
  place: string;
  street: string;
  homeNumber: string;
  reclamationReason: string;
  type: string;
}) => {
  return instance
    .get<{ termin: string }[]>("/reclamation/dates", {
      params: {
        street,
        homeNumber,
        place,
        reclamationReason,
        type,
      },
    })
    .then((res) => res.data);
};

const createReclamation = ({
  date,
  homeNumber,
  place,
  reclamationReason,
  street,
  type,
  message,
  reasons,
}: {
  place: string;
  street: string;
  homeNumber: string;
  reclamationReason: string;
  type: string;
  date: string;
  message?: string;
  reasons: string[];
}) => {
  return instance
    .post("/reclamation", {
      date,
      homeNumber,
      place,
      reclamationReason,
      street,
      type,
      message,
      reasons,
    })
    .then((res) => res.data);
};

const Reclamation = {
  get: {
    getAreas,
    getDates,
    getStreets,
  },
  post: {
    createReclamation,
  },
};

export default Reclamation;
